<script>
import {mapActions, mapMutations, mapGetters} from 'vuex';
import edit from './codeEdit';
import config from '@/modules/config/columns';
export default {
	created() {
	},
	props: {
		handlerCodeSearch: {
			type: Function,
			required: true
		},
		searchQuery: {
			type: Object,
			required: true
		}
	},
	data() {
        return {
			options: [{
				value: '选项1',
				label: '黄金糕'
				}, {
				value: '选项2',
				label: '双皮奶'
			}]
        }
    },
	methods: {
		addCodeModel() {
			this.$refs.edit.modelStatus(true);
		},
		...mapActions('nameRules', ['addCode']),
	},
	computed: {
		...mapGetters('nameRules', ['codeOption']),
		config() {
			return config;
		}
	},
	components: {
		edit
	}
}
</script>
<template>
<div class="name-search">
	<el-row :gutter="20">
	    <el-col :span="5">
	  	    <el-input v-model ="searchQuery.name" clearable
			    placeholder="请输入权限名称"
			></el-input>
	    </el-col>
		<el-col :span="6">
	        <el-button type="primary" @click="handlerCodeSearch">搜索</el-button>
	    </el-col>
	</el-row>
</div>
</template>
<style scoped lang="stylus">
.el-header
    line-height 60px
    padding 0 10px
.avatar-uploader
    display inline-block
    margin-left 80%

/deep/.el-date-editor.el-input, .el-date-editor.el-input__inner
    width auto
</style>